import { render, staticRenderFns } from "./RequiredField.vue?vue&type=template&id=de42e27c&scoped=true"
import script from "./RequiredField.vue?vue&type=script&lang=ts"
export * from "./RequiredField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de42e27c",
  null
  
)

export default component.exports